<script>
import SentToEducator from '@/components/booking/bookingList/sent-to-educator.vue'
import NoEducator from '../no-educator.vue'
import DayByDayEducator from '../day-by-day-educator.vue'
import BlockEducator from '../block-educator.vue'

export default {
  name: 'EducatorColumn',
  components: {
    SentToEducator,
    NoEducator,
    DayByDayEducator,
    BlockEducator,
  },
  props: {
    booking: { type: Object, default: null },
    isMobile: { type: Boolean, default: false },
    currentTabName: { type: String, required: true },
    isDayByDay: { type: Boolean, default: false },
    viewSidepanel: { type: Function, required: true },
    bookingStatusLabelType: { type: Object, required: true },
  },
  emits: ['viewCandidate'],
  computed: {
    uniqueBlockCandidates() {
      // if (this.isDayByDay || !Array.isArray(this.booking.blockDetails))
      //   return []

      // Case 1: groupId is 0 → take the main candidate directly
      if (this.booking.groupId === 0 && this.booking.candidate) {
        return [this.booking.candidate]
      }

      // Case 2: groupId not 0 → get unique candidates from blockDetails
      if (this.isDayByDay || !Array.isArray(this.booking.blockDetails))
        return []

      const map = new Map()
      for (const d of this.booking.blockDetails) {
        if (
          d.bookingStatus !== this.bookingStatusLabelType.Pending &&
          d.bookingStatus !== this.bookingStatusLabelType.Open
        ) {
          const c = d.candidate
          if (c && c.id != null && !map.has(c.id)) {
            map.set(c.id, c)
          }
        }
      }
      return Array.from(map.values())
    },
    canClickEducatorTd() {
      if (this.booking.bookingStatus === this.bookingStatusLabelType.Pending)
        return true
      if (this.booking.bookingStatus === this.bookingStatusLabelType.Open)
        return true

      if (this.isDayByDay) {
        if (this.booking.candidate) return false
        else return true
      } else {
        if (this.uniqueBlockCandidates.length) return false
        else return true
      }
    },
  },
  methods: {
    viewCandidate(candidate) {
      this.$emit('viewCandidate', candidate)
    },
  },
}
</script>

<template>
  <td
    v-if="
      (!isMobile &&
        currentTabName !== 'ApprovalRequired' &&
        currentTabName !== 'cancelled') ||
      (isMobile && currentTabName !== 'ApprovalRequired')
    "
    @click.stop="canClickEducatorTd && viewSidepanel(booking)"
  >
    <div class="educator-cell">
      <!-- EDUCATOR (desktop) -->
      <template
        v-if="
          !isMobile &&
          currentTabName !== 'ApprovalRequired' &&
          currentTabName !== 'cancelled'
        "
      >
        <SentToEducator
          v-if="booking.bookingStatus === bookingStatusLabelType.Pending"
        />

        <NoEducator
          v-else-if="booking.bookingStatus === bookingStatusLabelType.Open"
        />

        <template v-else>
          <DayByDayEducator
            v-if="isDayByDay"
            :candidate="booking.candidate"
            @viewCandidate="viewCandidate"
          />

          <BlockEducator
            v-else
            :unique-block-candidates="uniqueBlockCandidates"
            @viewCandidate="viewCandidate"
          />
        </template>
      </template>

      <!-- EDUCATOR (mobile) -->
      <template v-if="isMobile && currentTabName !== 'ApprovalRequired'">
        <div
          class="d-flex flex-row align-items-center align-center justify-content-center gap-2"
        >
          <SentToEducator
            v-if="booking.bookingStatus === bookingStatusLabelType.Pending"
            :is-mobile="isMobile"
            :classification-name="booking.classification.name"
          />

          <NoEducator
            v-else-if="booking.bookingStatus === bookingStatusLabelType.Open"
            :is-mobile="isMobile"
            :classification-name="booking.classification.name"
          />

          <template v-else>
            <DayByDayEducator
              v-if="isDayByDay"
              :candidate="booking.candidate"
              :is-mobile="isMobile"
              :classification-name="booking.classification.name"
              @viewCandidate="viewCandidate"
            />

            <!-- Block mobile: avatars only, names hidden -->
            <BlockEducator
              v-else
              :unique-block-candidates="uniqueBlockCandidates"
              :is-mobile="isMobile"
              :classification-name="booking.classification.name"
              @viewCandidate="viewCandidate"
            />
          </template>
        </div>
      </template>
    </div>
  </td>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-row.scss';
</style>
